import script from "./TrialExpiredModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrialExpiredModal.vue?vue&type=script&setup=true&lang=ts"

import "./TrialExpiredModal.vue?vue&type=style&index=0&id=d36b279c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d36b279c"]])

export default __exports__